import InnerMenu from './InnerMenu.vue';

export * from './types';
export default InnerMenu;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/innermenu/index.ts